<template>
  <!-- page-wrapper Start-->
  <div class="page-wrapper compact-wrapper" id="pageWrapper">
    <div class="page-body-wrapper">
      <div class="page-body">
        <!-- Breadcrumb & Title -->
        <div class="container-fluid">
          <div class="page-title">
            <div class="row">
              <div class="col-12 col-sm-6">
                <h3>Account Statement Report</h3>
              </div>
              <div class="col-12 col-sm-6">
                <ol class="breadcrumb">
                  <li class="breadcrumb-item">
                    <a class="home-item" href="/"><i data-feather="home"></i></a>
                  </li>
                  <li class="breadcrumb-item">Dashboard</li>
                  <li class="breadcrumb-item">Report</li>
                  <li class="breadcrumb-item active">Account Statement Report</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <!-- Breadcrumb & Title -->

        <!-- Container-fluid starts-->
        <div class="container-fluid list-products">
          <div class="row">
            <!-- Create New -->
            <div class="col-sm-12 col-lg-12">
              <div class="card">
                <div class="card-header pb-0">
                  <h5>Filter Report</h5>
                </div>
                <div class="card-body">
                  <!-- <form> -->
                  <div class="row g-3">
                    <div class="col-md-4">
                      <label class="form-label" for="title">Customer</label>
                      <!-- <select v-model="customer_id" class="form-control">
                        <option value="">Select customer</option>
                        <option
                          v-for="item in this.customerList"
                          :key="item.id"
                          :value="item.id"
                        >
                          {{ item.name }}
                        </option>
                      </select> -->
                      <Select2
                        v-model="customer_id"
                        :options="customerList"
                        @change="myChangeEvent($event)"
                        @select="mySelectEvent($event)"
                      />
                    </div>
                    <div class="col-md-4">
                      <label class="form-label" for="title">Customer Type</label>
                      <input class="form-control" type="date" v-model="from_date" />
                    </div>
                    <div class="col-md-4">
                      <label class="form-label" for="title">Select District</label>
                      <input class="form-control" type="date" v-model="to_date" />
                    </div>
                  </div>
                  <button class="btn btn-primary" type="submit" @click="onFilterAction">
                    Submit
                  </button>
                  <!-- </form> -->
                </div>
              </div>
            </div>

            <!-- Data table -->
            <div class="col-sm-12 col-lg-12" v-show="accountReport.length > 0">
              <div class="card">
                <div class="card-header pb-0">
                  <h5>List</h5>
                </div>
                <div class="card-body">
                  <div class="col-12 text-end">
                    <button class="btn btn-info my-3" @click="downloadPDF">
                      Download Report
                    </button>
                  </div>
                  <div class="table-responsive product-tabl">
                    <table class="display w-100" id="accountReportTBL">
                      <thead>
                        <tr align="center">
                          <th>Date</th>
                          <th>Invoice</th>
                          <th>Sub Total</th>
                          <th>Payment Method</th>
                          <th>Bank</th>
                          <th>Branch</th>
                          <th>Cheque</th>
                          <th>Cheque Date</th>
                          <th>Transaction Info</th>
                          <th>Reference</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          align="center"
                          v-for="(item, index) in accountReport"
                          :key="index"
                        >
                          <td>{{ moment(item.created_at).format("DD/MM/YYYY") }}</td>
                          <td>{{ item.inv_no ? "#" + item.inv_no : "" }}</td>
                          <td>
                            {{
                              item.payment_method ? "" : parseInt(item.sub_total_price)
                            }}
                          </td>
                          <td>
                            {{
                              item.payment_method
                                ? item.payment_method === 1
                                  ? "Cash"
                                  : item.payment_method === 2
                                  ? "Bank"
                                  : "Bkash"
                                : ""
                            }}
                          </td>
                          <td>
                            {{ item.bank_name ? item.bank_name : "" }}
                          </td>
                          <td>
                            {{ item.bank_branch ? item.bank_branch : "" }}
                          </td>
                          <td>
                            {{ item.cheque_number ? item.cheque_number : "" }}
                          </td>
                          <td>
                            {{
                              item.cheque_date
                                ? moment(item.cheque_date).format("DD-MM-YYYY")
                                : ""
                            }}
                          </td>
                          <td>
                            {{
                              item.bkash_transaction_id ? item.bkash_transaction_id : ""
                            }}
                          </td>
                          <td>
                            {{
                              item.bkash_transaction_id
                                ? item.bkash_transfer_reference
                                : ""
                            }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div class="col-12 text-end mt-5">
                      <h5>
                        Total Amount :
                        {{
                          this.otherInfo.totalINVAmount
                            ? parseInt(this.otherInfo.totalINVAmount)
                            : this.otherInfo.totalINVAmount
                        }}
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Container-fluid starts-->
      </div>
    </div>
  </div>
</template>

<script>
import "jquery/dist/jquery.min.js";
import "bootstrap/dist/css/bootstrap.min.css";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import ReportAPI from "../../../services/report.API.js";
// import $ from "jquery";
import customerAPI from "../../../services/customer.API.js";
import moment from "moment";
import jsPDF from "jspdf";
import "jspdf-autotable";
import Select2 from "vue3-select2-component";

export default {
  name: "accountReport",
  components: {
    Select2,
  },
  data() {
    return {
      moment: moment,
      customer_id: "",
      from_date: "",
      to_date: "",
      accountReport: [],
      customerList: [{ id: 0, text: "All" }],
      otherInfo: {
        openingBalance: 0,
        totalINVAmount: 0,
        totalReceiveAmount: 0,
        dueAmount: 0,
      },
    };
  },
  methods: {
    myChangeEvent(val) {
      console.log(val);
    },
    mySelectEvent({ id, name }) {
      console.log({ id, name });
      this.customer_id = id;
    },
    // addNew
    onFilterAction() {
      //   console.log(this.title, this.status);
      if (this.customer_id == "") {
        this.$moshaToast("Please enter Customer type", {
          type: "danger",
          position: "top-right",
          showIcon: true,
        });
      } else {
        let data = {
          customer_id: Number(this.customer_id),
          from_date: this.from_date,
          to_date: this.to_date,
        };
        ReportAPI.getAccountReport(data)
          .then((response) => {
            if (response?.data?.data?.length === 0) {
              this.$moshaToast("No data found", {
                type: "danger",
                position: "top-right",
                showIcon: true,
              });
              this.accountReport = response.data.data;
            }
            //   list
            this.totalAmount = response.data.totalAmount;
            this.accountReport = response.data.data;
            this.otherInfo.openingBalance = response.data.openingBalance;
            this.otherInfo.totalINVAmount = response.data.totalINVAmount;
            this.otherInfo.totalReceiveAmount = response.data.totalReceiveAmount;
            this.otherInfo.dueAmount = response.data.dueAmount;
          })
          .catch((error) => {
            // console.log(error.response.data.success);
            if (error.response.data.success === false) {
              this.$moshaToast(error.response.data.message, {
                type: "danger",
                position: "top-right",
                showIcon: true,
              });
            }
          });
      }
    },

    // selectedAction(item) {
    //   this.selectedItem = item;
    // },

    // download pdf
    downloadPDF() {
      const unit = "pt";
      const size = "A4"; // Use A1, A2, A3 or A4
      const orientation = "portrait"; // portrait or landscape

      // header/body data
      const columns = [
        [
          "Date",
          "Invoice",
          "Payment Method",
          "Bank",
          "Branch",
          "Cheque",
          "Cheque Date",
          "TRX ID",
          "Reference",
          "Sub Total",
        ],
      ];
      const data = this.accountReport.map((item) => [
        moment(item.created_at).format("DD-MM-YYYY"),
        item.inv_no ? "#" + item.inv_no : "",
        item.payment_method
          ? item.payment_method === 1
            ? "Cash"
            : item.payment_method === 2
            ? "Bank"
            : "Bkash"
          : "",
        item.bank_name ? item.bank_name : "",
        item.bank_branch ? item.bank_branch : "",
        item.cheque_number ? item.cheque_number : "",
        item.cheque_date ? moment(item.cheque_date).format("DD-MM-YYYY") : "",
        item.bkash_transaction_id ? item.bkash_transaction_id : "",
        item.bkash_transaction_id ? item.bkash_transfer_reference : "",
        item.payment_method ? "" : parseInt(item.sub_total_price),
      ]);

      // alignment
      const marginLeft = 40;
      const doc = new jsPDF(orientation, unit, size);
      // new line
      // var pageWidth = doc.internal.pageSize.width || doc.internal.pageSize.getWidth();
      // doc.setFontSize(13);

      // if (itemData.paid_status === 0) {
      //   doc.text("Payment Status : Unpaid", 40, 145);
      // } else {
      //   doc.text("Payment Status : Paid", 40, 145);
      // }
      // doc.text("Sub-Total : " + parseInt(itemData.sub_total_price), 40, 165);
      // doc.text("Total : " + parseInt(itemData.total_price), 40, 185);
      // doc.setFontSize(15);
      var startingPage = doc.internal.getCurrentPageInfo().pageNumber;
      const title = "Report";

      let content = {
        startY: 150,
        head: columns,
        body: data,
        margin: {
          bottom: 120,
          top: 150,
        },
      };

      doc.setFont("helvetica", "bold");
      doc.setFontSize(15);
      doc.text(title, marginLeft, 50);

      doc.autoTable(content);

      doc.setPage(startingPage);
      doc.save(
        "Account_statement_report(" + moment(new Date()).format("YYYY-MM-DD") + ").pdf"
      ); // Auto print code
      doc.autoPrint();
    },
  },
  mounted() {
    // customer list
    customerAPI.getList().then((response) => {
      this.customerList = [
        ...this.customerList,
        ...response?.data?.data?.map((e) => {
          return { ...e, text: e?.name };
        }),
      ];
    });
  },
};
</script>

<style scoped>
thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: #dbd4d4;
  border-style: solid;
  border-width: 1px;
  padding: 10px 5px;
}

.btn {
  margin: 5px;
}

th {
  text-align: center !important;
}

.card {
  border-radius: 1.5em;
  border: 1px solid white;
}

.card-header:first-child {
  border-radius: 1.5em;
}

.modal-backdrop.fade.show {
  opacity: 1 !important;
  display: none;
}

.modal-body.ct h5 {
  text-align: center;
}
</style>
